import { useMemo } from 'react';

import { useGetContacts } from '~hooks/useGetContacts';

export const useCurrentBot = ({
	recipientId,
}: {
	recipientId: string | number;
}) => {
	const { data, isSuccess, isLoading } = useGetContacts({
		skip: !recipientId,
		recipientId,
	});

	const transformedData = useMemo(() => {
		const resp = data ?? { contacts: {}, inaccessibleContacts: {} };

		let isSafeBot = undefined;
		const visibility = (
			resp.contacts[+recipientId] ?? resp.inaccessibleContacts[+recipientId]
		)?.visibility;
		if (visibility) {
			isSafeBot = visibility === 'sfw';
		}

		return {
			bot: resp.contacts[+recipientId] ?? {},
			isSafeBot,
		};
	}, [data, recipientId]);

	// TODO: Make return type
	return {
		bot: transformedData.bot,
		isSafeBot: transformedData.isSafeBot,
		botSuccess: isSuccess,
		botLoading: isLoading,
		botLastMessage: transformedData.bot.lastMessage || null,
		botUnreadMessages: transformedData.bot.unreadMessagesCount || 0,
		botTotalMessages: transformedData.bot.totalMessagesCount || 0,
	};
};
